import React from 'react';
import styled from '@emotion/styled';
import Badge from 'src/components/Badge';
import type { ItemDetail } from 'src/types/itemInventory';
import Category from './Category';
import ItemRow from './ItemRow';
interface Props {
  items: ItemDetail[];
}
const ItemUseCountBadge = styled(Badge)`
  position: absolute;
  top: -1px;
  inset-inline-start: 11px;
  border: 1px solid ${({
  theme
}) => theme.color.bg2};
  background-color: ${({
  theme
}) => theme.color.primary1};
  color: ${({
  theme
}) => theme.color.contentDeepFixed};
`;
const ItemList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const ConsumablePurchase: React.FC<Props> = ({
  items
}) => {
  return <Category title='inventory_single_use_item_title' description='inventory_single_use_item_desc' data-sentry-element="Category" data-sentry-component="ConsumablePurchase" data-sentry-source-file="ConsumablePurchase.tsx">
      <ItemList data-sentry-element="ItemList" data-sentry-source-file="ConsumablePurchase.tsx">
        {items.map(item => <ItemRow key={`consumable-${item.inventoryId}`} item={item} useCountLeftBadge={item.useCount ? <ItemUseCountBadge type='number' size='small' value={item.useCount} /> : undefined} />)}
      </ItemList>
    </Category>;
};
export default ConsumablePurchase;